import { forwardRef, useImperativeHandle, useState } from "react";
import { Bottomsheet } from "./bottomsheet";
import { Button } from "./ui/button/button";
import { toast } from "./ui/use-toast";
import APP_ASSETS from "@/assets";
import classNames from "classnames";
import { useMerchant } from "@/contexts";
import { trackAmplitudeEvent } from "@/utils/amplitude";

type BankSelectorType = {
  updateBank?: (name: string) => void;
  ref: any;
};

export const banks = [
  {
    name: "State Bank Of India",
    img: APP_ASSETS.ICONS.SBI_BANK,
    value: "sbi",
  },
  {
    name: "Canara Bank",
    img: APP_ASSETS.ICONS.CANARA_BANK,
    value: "canara",
  },
];

export const BankSelector: React.FC<BankSelectorType> = forwardRef(
  ({}, ref) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [bankName, setBankName] = useState("");
    const { setMerchantBankName } = useMerchant();

    const toggle = () => {
      setIsOpen(!isOpen);
    };

    useImperativeHandle(ref, () => {
      return {
        toggle,
        isOpen,
      };
    });

    const selectBank = (name: string) => {
      setBankName(name);
    };

    const reset = () => {
      setBankName("");
    };

    const handleSetBank = () => {
      trackAmplitudeEvent("BANK_SELECTED");
      setMerchantBankName(bankName);
      toast({
        title: `${bankName.toUpperCase()} Successfully updated as bank.`,
      });
      toggle();
      reset();
    };

    return (
      <Bottomsheet
        title={"Choose Bank"}
        description={"Choose Your bank to proceed."}
        includeActionButton
        drawerParams={{
          open: isOpen,
        }}
        onClose={toggle}>
        <div className="mx-5">
          <div className="flex flex-col justify-center gap-3 pb-[16px] md:flex-row">
            {banks.map((bank) => {
              return (
                <div
                  className={classNames({
                    "flex items-center rounded border-[1px] border-stroke-grey bg-bg-grey px-[24px] py-[14px] hover:cursor-pointer hover:border-stroke-primary":
                      true,
                    "border-stroke-primary font-medium": bankName == bank.value,
                  })}
                  onClick={() => {
                    selectBank(bank.value);
                  }}>
                  <img
                    src={bank.img}
                    className={classNames({
                      "h-[52px]": bank.value == "canara",
                      "h-[48px]": bank.value == "sbi",
                    })}
                  />
                  <p className="ml-2 text-text-light">{bank.name}</p>
                </div>
              );
            })}
          </div>
          <Button label={"Confirm"} onClick={handleSetBank} widthFull />
        </div>
      </Bottomsheet>
    );
  },
);
